import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap';

// Ng2-select
import { SelectModule } from 'ng-select';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

// Timepicker
import { TimepickerModule } from 'ngx-bootstrap';
// Datepicker
import { BsDatepickerModule } from 'ngx-bootstrap';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { PMStatusNum2StatusNameModule, DisplayIdModule } from '../../../directives';
import { CustomInterceptor } from './../../../helper';

// Routing
import { PreventiveMaintenanceRoutingModule } from './preventive-maintenance-routing.module';

// import { PreventiveMaintenanceAddComponent, PreventiveMaintenanceAddService } from './preventive-maintenance-add';
import { PreventiveMaintenanceEditComponent, PreventiveMaintenanceEditService } from './preventive-maintenance-edit';
import { PreventiveMaintenanceDetailComponent, PreventiveMaintenanceDetailService,
  PreventiveMaintenanceEquipmentSummaryService, PreventiveMaintenanceChangeLogService,
  PreventiveMaintenanceCancelService } from './preventive-maintenance-detail';
import { PreventiveMaintenanceSummaryComponent, PreventiveMaintenanceSummaryService } from './preventive-maintenance-summary';
import { JobDetailService } from '../job/job-detail';
import { PreventiveMaintenanceAssignFormComponent, PreventiveMaintenanceAssignFormService } from './preventive-maintenance-assign-form';
import { PreventiveMaintenanceCreateComponent } from './preventive-maintenance-create/preventive-maintenance-create.component';
import { StoreModule } from '@ngrx/store';
import { pmReducer } from './reducers/pm-create.reducer';
import { PreventiveMaintenanceCreateService } from './preventive-maintenance-create';
import { PreventiveMaintenancePdfAddComponent } from './preventive-maintenance-pdf-add/preventive-maintenance-pdf-add.component';
import { PreventiveMaintenancePdfSummaryComponent } from './preventive-maintenance-pdf-summary/preventive-maintenance-pdf-summary.component';
import { PreventiveMaintenanceService } from './preventive-maintenance.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SelectModule,
    AngularMultiSelectModule,
    ModalModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PMStatusNum2StatusNameModule,
    TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
    
    PreventiveMaintenanceRoutingModule,
    DisplayIdModule,
    ReactiveFormsModule,
    StoreModule.forRoot({pmCreate: pmReducer}),


  ],
  declarations: [
    // PreventiveMaintenanceAddComponent,
    PreventiveMaintenanceEditComponent,
    PreventiveMaintenanceDetailComponent,
    PreventiveMaintenanceSummaryComponent,
    PreventiveMaintenanceAssignFormComponent,
    PreventiveMaintenanceCreateComponent,
    PreventiveMaintenancePdfAddComponent,
    PreventiveMaintenancePdfSummaryComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    DatePipe,
    // PreventiveMaintenanceAddService,
    PreventiveMaintenanceAssignFormService,
    PreventiveMaintenanceEditService,
    PreventiveMaintenanceSummaryService,
    PreventiveMaintenanceDetailService,
    PreventiveMaintenanceEquipmentSummaryService,
    PreventiveMaintenanceChangeLogService,
    PreventiveMaintenanceCancelService,
    PreventiveMaintenanceCreateService,
    PreventiveMaintenanceService,
    JobDetailService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ],
})
export class PreventiveMaintenanceModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance.module.ts